module.exports = __webpack_public_path__ + "static/media/send-money.d7bf74c0.svg";